import Validator from 'validatorjs';

export default {
  inject: {
    register: {default: () => (() => null)},
    validate: {default: () => (() => null)},
  },
  props: {
    id: {
      type: String,
    },
    slug: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    hint: {
      type: String,
    },
    error: {
      type: String,
    },
    validations: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    escape: {
      type: Boolean,
      default: true
    },
    isMultipart: {
      type: Boolean,
      default: false,
    },
    forceValidateOnChange: {
      type: Boolean,
      default: false,
    },
    default: {
      type: String,
    },
  },
  data() {
    return {
      fieldHint: this.hint,
      fieldValue: this.value,
      defaultValue: this.default,
      errors: [],
      messages: [],
      shouldValidate: false,
      validateOnChange: this.forceValidateOnChange,
      enabled: !this.disabled
    }
  },
  computed: {
    fieldLabel() {
      return this.required ? `${this.label} *` : this.label;
    },
    valid() {
      return this.errors.length === 0;
    },
    isValid() {
      return !this.shouldValidate || (this.shouldValidate && this.valid);
    },
    isSuccess() {
      return this.shouldValidate && this.valid;
    },
    isDanger() {
      return this.shouldValidate && !this.valid;
    }
  },
  created() {
    if (this.error) {
      this.errors.push(this.error);
      this.shouldValidate = true;
    }
    try {
      Validator.getMessages(window.App.getCurrentLocale());
      Validator.useLang(window.App.getCurrentLocale());
    } catch (e) {
      Validator.useLang(Validator.getDefaultLang());
    }
  },
  mounted() {
    this.register(this);
  },
  methods: {
    setValue(value) {
      this.fieldValue = value;
      this.$root.$emit('field.setValue', this);
    },
    getValue() {
      return this.fieldValue;
    },
    getDefaultValue() {
      return this.defaultValue;
    },
    setDefaultValue(value) {
      return this.defaultValue = value;
    },
    getValidations() {
      return this.validations;
    },
    getLabel() {
      return this.label;
    },
    doValidate() {
      if (this.validateOnChange) {
        this.shouldValidate = true;
        this.validateField();
      }
    },
    validateField(fields = {}, labels = {}) {
      let validations = {};

      validations[this.slug] = this.getValidations();

      let fieldValues = {
        [this.slug]: this.fieldValue,
      };
      let fieldLabels = {
        [this.slug]: this.label,
      }

      let validator = new Validator(Object.assign(fieldValues, fields), validations);

      validator.setAttributeNames(Object.assign(fieldLabels, labels));

      validator.passes();

      if (validator.errors.first(this.slug)) {
        this.errors = [validator.errors.first(this.slug)];
      } else {
        this.errors = [];
      }
      if (this.errors.length) {
        this.$set(this.messages, this.slug, this.errors);
      } else {
        this.$delete(this.messages, this.slug);
      }

      return {
        valid: Object.keys(this.errors).length === 0,
        messages: this.messages,
      }
    },
    resetValidation() {
      this.shouldValidate = false;
      this.errors = [];
      this.messages = [];
    },
    triggerChangeAndValidate() {
      if (this.validateOnChange) {
        if (typeof this.validate === "function") {
          this.validate(this);
        } else {
          this.doValidate();
        }
      }
      this.$root.$emit('field.changed', this);
      this.$emit('change', this.getValue(), this);
    }
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/mixins/FormField.js